import styled from 'styled-components';
import { Breakpoints, Colors } from 'styles/Constants';

export const SectionForm = styled.div`
  margin: 50px 10%;
  width: 80%;
  @media (max-width: ${Breakpoints.medium}) {
    margin: 0 0%;
    width: 100%;
  }
`;

export const ButtonStyled = styled.div`
  button {
    text-align: center;
    margin: auto;
    margin-top: 30px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }
`;

export const CheckboxGroup = styled.div`
  margin-top: 15px;
  display: flex;
  gap: 40px;
  align-items: center;
  white-space: nowrap;

  label {
    margin: 0;
    display: inline-table;
  }

  .swipe-checkbox {
    margin-left: 50px;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: ${Breakpoints.medium}) {
    display: grid;
  }

  .checkbox-parent {
    margin-top: 30px;
    display: grid;
    grid-template-columns: repeat(10, 1fr);
    grid-column-gap: 45px;
    .checkbox-child {
      grid-column: span 2;
      align-items: center;
      display: flex;
      margin-bottom: 20px;
      input {
        height: 15px;
        width: 15px;
        padding: 7px;
        margin: 0px;
      }
      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        font-size: 14px;
        margin: 0 0 0 5px;
      }
    }
  }

  .bonus-checkbox {
    display: flex;
    align-items: center;
  }

  label {
    padding: 10px;
    width: 10%;
    color: #4d4d4d;
    font-size: 1rem;
    font-weight: 600;
    margin-right: 40px;
    @media (max-width: ${Breakpoints.medium}) {
      padding: 0px;
    }
  }

  input {
    margin: 10px 0;
    @media (max-width: ${Breakpoints.medium}) {
      display: grid;
      width: 100%;
      margin-left: 0%;
    }
  }

  .checkbox {
    display: flex;
    width: 100%;
    margin: 10px 0 0px 10px;
    @media (max-width: ${Breakpoints.medium}) {
      width: 50%;
      margin-top: 0px;
      margin-right: 1px;
    }
  }

  div.dropdown-filter-container {
    margin: 10px 0;
    margin-right: 20%;
    @media (max-width: ${Breakpoints.medium}) {
      display: grid;
      width: 100%;
      margin-left: 0%;
    }
  }

  div.dropdown-filter-content__control {
    width: 200px;
    margin-left: -15px;
    border: 1px solid #979797;
    background-color: transparent;
    box-shadow: none;
    height: 30px;
    border-radius: 10px !important;

    &:hover,
    &:focus-within {
      border-color: ${Colors.primaryDarkBlue};
      cursor: pointer;
    }
  }

  div.dropdown-filter-content__single-value {
    color: #3e66fe;
    font-weight: 500;
    font-size: 13px;
    text-transform: uppercase;
  }

  div.dropdown-filter-content__value-container {
    margin-top: -6px;
  }

  span.dropdown-filter-content__indicator-separator {
    display: none;
  }

  div.dropdown-filter-content__indicator {
    color: rgba(0, 0, 0, 0.54);
  }

  div.dropdown-filter-content__placeholder {
    padding-bottom: 15px;
    font-size: 15px;
    color: ${Colors.inactive};
  }

  div.dropdown-filter-content__menu {
    margin-top: 1px;
    width: 170px;
    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
      0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14);
    z-index: 5;
  }

  div.dropdown-filter-content__menu-list {
    padding-top: 0;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  div.dropdown-filter-content__option {
    padding: 6px 8px;
    font-size: 14px;
  }

  div.dropdown-filter-content__option--is-focused {
    background: transparent;
  }

  div.dropdown-filter-content__option:hover,
  div.dropdown-filter-content__option--is-focused:hover,
  div.dropdown-filter-content__option--is-selected {
    background: rgba(0, 0, 0, 0.08);
    font-weight: 500;
    color: #3e66fe;
  }
  .m-l-0 {
    margin-left: 0px !important;
  }

  .w-100 {
    width: 100%;
  }
  .PhoneInput {
    display: flex;
    flex-direction: row-reverse; /* Mueve la bandera al final */
    align-items: center;
    width: 150%;
    margin-left: -15px;
  }

  .PhoneInputCountry {
    margin-left: 10px;
    margin-right: 0;
  }

  .PhoneInputInput {
    flex: 1;
    width: 100%;
    border-radius: 10px;
  }
  .dropdown-filter-content__control {
    border-radius: 30px;
    border: 1px solid #aaa;
  }
`;

export const TextCheckbox = styled.p`
  margin: 10px;
  color: #4d4d4d;
  font-size: 1rem;
  font-weight: 600;
  @media (max-width: ${Breakpoints.medium}) {
    width: 100%;
  }
`;
